import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card border-0 rounded-3 bg-white p-4 mb-4 pb-0" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-lg-8" }
const _hoisted_4 = { class: "form-group mb-4" }
const _hoisted_5 = { class: "d-flex align-items-center" }
const _hoisted_6 = { class: "price-input flex-grow-1 ms-3 position-relative" }
const _hoisted_7 = { class: "d-flex justify-content-between mb-1" }
const _hoisted_8 = {
  id: "min-value",
  class: "d-block text-black fw-medium fs-13"
}
const _hoisted_9 = {
  id: "max-value",
  class: "d-block text-black fw-medium fs-13"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("form", null, [
      _createElementVNode("div", _hoisted_2, [
        _cache[3] || (_cache[3] = _createStaticVNode("<div class=\"col-lg-3\" data-v-10197200><div class=\"position-relative mb-4\" data-v-10197200><input type=\"text\" class=\"form-control bg-body-bg border-0\" placeholder=\"Search here.....\" data-v-10197200><button type=\"submit\" class=\"position-absolute top-50 end-0 translate-middle-y bg-transparent p-0 border-0 pe-3 pt-2 text-primary\" data-v-10197200><span class=\"material-symbols-outlined\" data-v-10197200>search</span></button></div></div><div class=\"col-lg-3\" data-v-10197200><div class=\"form-group mb-4\" data-v-10197200><select class=\"form-select form-control bg-body-bg border-0\" aria-label=\"Default select example\" data-v-10197200><option selected data-v-10197200>Category</option><option value=\"1\" data-v-10197200>NFT</option><option value=\"2\" data-v-10197200>Bird</option><option value=\"3\" data-v-10197200>Pool</option></select></div></div><div class=\"col-lg-3\" data-v-10197200><div class=\"form-group mb-4\" data-v-10197200><select class=\"form-select form-control bg-body-bg border-0\" aria-label=\"Default select example\" data-v-10197200><option selected data-v-10197200>File Type</option><option value=\"1\" data-v-10197200>Full File</option><option value=\"2\" data-v-10197200>Zip FIle</option><option value=\"3\" data-v-10197200>Only Card</option></select></div></div><div class=\"col-lg-3\" data-v-10197200><div class=\"form-group mb-4\" data-v-10197200><select class=\"form-select form-control bg-body-bg border-0\" aria-label=\"Default select example\" data-v-10197200><option selected data-v-10197200>Sales Type</option><option value=\"1\" data-v-10197200>Full File</option><option value=\"2\" data-v-10197200>Zip FIle</option><option value=\"3\" data-v-10197200>Only Card</option></select></div></div>", 4)),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _cache[2] || (_cache[2] = _createElementVNode("div", { class: "flex-shrink-0" }, [
                _createElementVNode("span", { class: "fs-14 fw-semibold" }, "Price:")
              ], -1)),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("span", _hoisted_8, " $" + _toDisplayString(_ctx.minPrice), 1),
                  _createElementVNode("span", _hoisted_9, " $" + _toDisplayString(_ctx.maxPrice), 1)
                ]),
                _withDirectives(_createElementVNode("input", {
                  type: "range",
                  max: "5000",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.minPrice) = $event)),
                  onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.updateRange && _ctx.updateRange(...args)))
                }, null, 544), [
                  [_vModelText, _ctx.minPrice]
                ])
              ])
            ])
          ])
        ]),
        _cache[4] || (_cache[4] = _createElementVNode("div", { class: "col-lg-4" }, [
          _createElementVNode("div", { class: "form-group mb-4 text-end" }, [
            _createElementVNode("button", { class: "btn btn-primary py-2 px-5" }, "Filter")
          ])
        ], -1))
      ])
    ])
  ]))
}